// Module
var code = "<p class=\"note mt-2rem\"> <strong>NOTE:</strong> Under <strong>Your Loan Details</strong> there may be additional messaging depending on the owner of your loans. If the owner of your loan assesses late fees, you may see the above message. This portion will tell you the late fee that corresponds with each due date. </p> ";
// Exports
export default code;